import { render, staticRenderFns } from "./ChallengesTable.vue?vue&type=template&id=107f2da8"
import script from "./ChallengesTable.vue?vue&type=script&lang=js"
export * from "./ChallengesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports